export default {
  getCarts: (cart_id, axios, currency) =>
    axios.post("/cart", {
      action: "getCarts",
      customer: "guest",
      currency,
      cart_id
    })
};
